/**
 * @author Junaid Atari <mj.atari@gmail.com>
 * @see https://github.com/blacksmoke26/dawn-of-man-generator
 * @since 2024-07-06
 * @version 2.5.0
 */

// types
import {environment} from './types';

export const resetValues: environment.Environment = {
  noiseAmplitudes: null,
  resourceFactor: null,
  distanceHeightOffset: null,
  fordDistanceFactor: null,
  sunAngleFactor: null,
  backdropScale: null,
  deposits: null,
  depositOverridePrototypes: null,
  detailOverridePrototypes: null,
  propOverridePrototypes: null,
  globalTreeDensity: null,
  treesEverywhere: null,
  trees: null,
  treeOverridePrototypes: null,
  seasons: null,
};
